export const FLASHY_EVENTS = {
    CREATE_OR_UPDATE: 'create_or_update',
    SET_CUSTOMER: 'set_customer',
} as const;
